import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddNews(props) {
  return(
    <PostAdd 
      targetVid={"news_categories"}
      addPostEndpoint={apiEndpoints.news}
      editRoute={"/news/edit"}
      entityType={"news"}
      pageTitle={"Create a news post"}
      returnRoute={"/news-creator"}
      categoryName={"news"}
    />
  )
}
